import React from 'react';
import PropTypes from 'prop-types';
import DiscordButton from '../DiscordButton';
import discord from '../../Assets/Images/discord.png';
import Container from './styles';

const loginLink = `https://discord.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_URL}/login&response_type=code&scope=guilds%20email%20identify`;

const LoginModal = ({ isConnected }) => (
  <Container isConnected={isConnected} screenWidth={window.innerWidth}>
    <p>
      Connecte-toi avec ton Discord pour accéder à toutes les fonctionnalités
    </p>
    <DiscordButton href={loginLink}>
      <img src={discord} width="22px" />
      Se connecter
    </DiscordButton>
  </Container>
);

LoginModal.propTypes = {
  isConnected: PropTypes.bool.isRequired,
};

export default LoginModal;
